import PropTypes from 'prop-types'

import {Map} from 'immutable'
import {useState} from 'react'
import {useForm, FormProvider} from 'react-hook-form'

import {useMutation} from '@apollo/client'
import {Stack} from '@mui/material'

import {ModalHeader} from '../../../../../shared_components/core/modals/ModalHeaders'
import Button from '../../../../../shared_components/mui_base_components/button/Button'
import ButtonGroup from '../../../../../shared_components/core/buttons/ButtonGroup'
import Email from '../../../../../shared_components/forms/v3/Email'
import LinkButton from '../../../../../shared_components/mui_base_components/link_button/LinkButton'
import Name from '../../../../../shared_components/forms/v3/Name'
import Select from '../../../../../shared_components/forms/v3/Select'

import {DEPUTY_VALIDATION} from '../../../../../graphql/mutations/deputy'

import './addDeputyStepOne.scss'

const RELATIONSHIPS = [ // Temporary stubbing of relationships until we get them from the DB. --BLR
  {label: 'Select a relationship', value: ''},
  {label: 'Spouse/Domestic Partner', value: 'Spouse/Domestic Partner'},
  {label: 'Child', value: 'Child'},
  {label: 'Parent', value: 'Parent'},
  {label: 'Sibling', value: 'Sibling'},
  {label: 'Friend', value: 'Friend'},
  {label: 'Advisor', value: 'Advisor'},
  {label: 'Attorney', value: 'Attorney'},
  {label: 'Caregiver/Sitter', value: 'Caregiver/Sitter'},
  {label: 'Other', value: 'Other'}
]

const AddDeputyStepOne = props => {
  const [deputyValidation] = useMutation(DEPUTY_VALIDATION, {errorPolicy: 'all'})
  const [processing, setProcessing] = useState(false)

  const methods = useForm({defaultValues: props.deputy})

  const handleSubmitForQuarterback = data => {
    setProcessing(true)

    const payload = {
      type: 'draft-deputy-validations',
      attributes: {
        email: data.email,
        'first-name': data['first-name'],
        'last-name': data['last-name'],
        'user-id': props.clientUserId
      }
    }

    props.createResource(payload)
      .then(response => {
        setProcessing(false)

        props.nextStep({
          ...data,
          firmUser: response.data.attributes['firm-user']
        })
      })
      .catch(error => {
        setProcessing(false)

        methods.setError('email', {
          type: 'manual',
          message: error.response.data.errors[0].title
        })
      })
  }

  const submit = data => {
    setProcessing(true)

    deputyValidation({
      variables: {
        input: {
          email: data.email,
          firstName: data['first-name'],
          lastName: data['last-name']
        }
      },
      onCompleted: response => {
        setProcessing(false)

        props.nextStep({...data, firmUser: response.deputyValidation.firmUser})
      },
      onError: error => {
        setProcessing(false)

        methods.setError('email', {
          type: 'manual',
          message: error.graphQLErrors[0].extensions.title
        })
      }
    })
  }

  const handleSubmit = data => {
    if (props.userConfig.get('quarterback'))
      handleSubmitForQuarterback(data)
    else
      submit(data)
  }

  return (
    <div className='add-deputy-step-one'>
      <ModalHeader
        heading='Who are you adding as your Deputy?'
        subheading='It can be your spouse/partner, family member, or anyone
                    you trust. You have full control over what you share with
                    them.'
      />
      <FormProvider {...methods}>
        <Stack component='form' gap={2}>
          <Name />
          <Email />
          <Select
            required
            name='deputy-relationship'
            label='Relationship'
            placeholder='Select a relationship'
            errorMessage='Please select the relationship.'
            options={RELATIONSHIPS}
          />
        </Stack>
        <ButtonGroup>
          <Button
            loading={processing}
            onClick={methods.handleSubmit(handleSubmit)}>
            Choose permissions
          </Button>
          {
            props.showSkipLinkButton && (
              <LinkButton disabled={processing} onClick={props.handleSkip}>
              Skip
              </LinkButton>
            )
          }
        </ButtonGroup>
      </FormProvider>
    </div>
  )
}

AddDeputyStepOne.propTypes = {
  clientUserId: PropTypes.number,
  createResource: PropTypes.func,
  deputy: PropTypes.object,
  handleSkip: PropTypes.func,
  nextStep: PropTypes.func,
  showSkipLinkButton: PropTypes.bool,
  userConfig: PropTypes.instanceOf(Map)
}

export default AddDeputyStepOne
